import React from 'react';
const SystemInformation =()=>{
    return (
        <div>
            系统信息
        </div>
    )
}
export default SystemInformation